import { createContext } from "react";

type PageAnalyticsContextType = {
	pageVariant: string | null;
	setPageVariant: (variant: string | null) => void;
};

const defaultContextValue: PageAnalyticsContextType = {
	pageVariant: null,
	setPageVariant: () => {},
};

export const PageAnalyticsContext = createContext<PageAnalyticsContextType>(defaultContextValue);
